(function () {
  'use strict';

  function initStartForm(formEl) {
    if (!formEl || formEl.getAttribute('data-start-form-initialized') === 'true') {
      return;
    }

    formEl.setAttribute('data-start-form-initialized', 'true');

    var root = formEl.closest('section') || formEl;
    var routeGrid = root.querySelector('[data-route-grid]');
    var routeRadios = root.querySelectorAll('[data-route-radio]');
    var requiredMsg = root.querySelector('[data-route-required-message]');
    var liveStatus = root.querySelector('[data-route-live-status]');
    var formFields = root.querySelector('[data-form-fields]');
    var formIntro = root.querySelector('[data-form-intro]');
    var confirmField = root.querySelector('[data-confirm-field]');
    var confirmCheckbox = root.querySelector('[data-confirm-checkbox]');
    var confirmText = root.querySelector('[data-confirm-text]');
    var routeValueInput = root.querySelector('[data-route-value]');
    var programmeValueInput = root.querySelector('[data-programme-value]');
    var formLiveStatus = root.querySelector('[data-form-live-status]');
    var privacyCheckbox = root.querySelector('[data-privacy-checkbox]');
    var submitButton = root.querySelector('[data-submit-button]');
    var successEl = root.querySelector('[data-form-success]');

    if (successEl) {
      successEl.focus();
      return;
    }

    var programmeLabelsRoot = document.querySelector('[data-programme-labels]');
    var programmeLabels = {};

    if (programmeLabelsRoot) {
      programmeLabelsRoot.querySelectorAll('[data-key]').forEach(function (el) {
        programmeLabels[el.getAttribute('data-key')] = el.getAttribute('data-label');
      });
    }

    function findRouteRadio(value) {
      var matchedRadio = null;

      routeRadios.forEach(function (radio) {
        if (radio.value === value) {
          matchedRadio = radio;
        }
      });

      return matchedRadio;
    }

    function selectRoute(value, programme, shouldScroll) {
      var radio = findRouteRadio(value);

      if (!radio) {
        return;
      }

      radio.checked = true;

      if (routeValueInput) {
        routeValueInput.value = value;
      }

      if (programmeValueInput) {
        programmeValueInput.value = '';
      }

      var intro =
        radio.getAttribute('data-intro-message') ||
        'Choose a route above to begin.';

      if (value === 'group' && programme && programmeLabels[programme]) {
        intro += ' (' + programmeLabels[programme] + ')';

        if (programmeValueInput) {
          programmeValueInput.value = programmeLabels[programme];
        }
      }

      if (formIntro) {
        formIntro.textContent = intro;
      }

      var needsConfirm =
        radio.getAttribute('data-needs-confirm') === 'true';

      var confirmMessage =
        radio.getAttribute('data-confirm-message') || '';

      if (confirmField && confirmCheckbox) {
        if (needsConfirm && confirmMessage) {
          confirmField.style.display = 'block';
          confirmCheckbox.required = true;

          if (confirmText) {
            confirmText.textContent = confirmMessage;
          }
        } else {
          confirmField.style.display = 'none';
          confirmCheckbox.required = false;
          confirmCheckbox.checked = false;
          confirmCheckbox.setAttribute('aria-invalid', 'false');
        }
      }

      if (formFields) {
        formFields.style.display = 'block';
      }

      if (requiredMsg) {
        requiredMsg.style.display = 'none';
      }

      if (liveStatus) {
        liveStatus.textContent =
          'Route selected. Form is now visible below.';
      }

      if (shouldScroll !== false && formFields) {
        formFields.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }

    routeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        selectRoute(this.value, '', true);
      });
    });

    function markError(fieldEl, inputEl, show) {
      if (fieldEl) {
        fieldEl.classList.toggle('has-error', show);
      }

      if (inputEl) {
        inputEl.setAttribute('aria-invalid', show ? 'true' : 'false');
      }

      var errorEl = fieldEl
        ? fieldEl.querySelector('.field-error')
        : null;

      if (errorEl) {
        errorEl.style.display = show ? 'block' : 'none';
      }
    }

    formEl.querySelectorAll('input, textarea, select').forEach(function (input) {
      input.addEventListener('input', function () {
        var fieldEl = input.closest('.field');

        if (fieldEl) {
          markError(fieldEl, input, false);
        }
      });

      input.addEventListener('change', function () {
        var fieldEl = input.closest('.field');

        if (fieldEl) {
          markError(fieldEl, input, false);
        }
      });
    });

    formEl.addEventListener('submit', function (event) {
      var routeSelected =
        routeValueInput && routeValueInput.value.trim() !== '';

      if (!routeSelected) {
        event.preventDefault();

        if (requiredMsg) {
          requiredMsg.style.display = 'block';
        }

        if (routeGrid) {
          routeGrid.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }

        if (routeRadios.length) {
          routeRadios[0].focus();
        }

        return;
      }

      var valid = true;
      var firstInvalid = null;
      var requiredInputs = formEl.querySelectorAll('[data-required]');

      requiredInputs.forEach(function (input) {
        var fieldEl = input.closest('.field');

        var value =
          typeof input.value === 'string'
            ? input.value.trim()
            : '';

        var empty = value === '';

        var emailInvalid =
          input.hasAttribute('data-email') &&
          !input.checkValidity();

        var invalid = empty || emailInvalid;

        markError(fieldEl, input, invalid);

        if (invalid) {
          valid = false;
          firstInvalid = firstInvalid || input;
        }
      });

      if (confirmCheckbox && confirmCheckbox.required) {
        var confirmOk = confirmCheckbox.checked;

        var confirmErrorEl = confirmField
          ? confirmField.querySelector('.field-error')
          : null;

        confirmCheckbox.setAttribute(
          'aria-invalid',
          confirmOk ? 'false' : 'true'
        );

        if (confirmErrorEl) {
          confirmErrorEl.style.display =
            confirmOk ? 'none' : 'block';
        }

        if (!confirmOk) {
          valid = false;
          firstInvalid = firstInvalid || confirmCheckbox;
        }
      }

      if (privacyCheckbox) {
        var privacyOk = privacyCheckbox.checked;
        var privacyField = privacyCheckbox.closest('.field');

        var privacyErrorEl = privacyField
          ? privacyField.querySelector('.field-error')
          : null;

        privacyCheckbox.setAttribute(
          'aria-invalid',
          privacyOk ? 'false' : 'true'
        );

        if (privacyErrorEl) {
          privacyErrorEl.style.display =
            privacyOk ? 'none' : 'block';
        }

        if (!privacyOk) {
          valid = false;
          firstInvalid = firstInvalid || privacyCheckbox;
        }
      }

      if (!valid) {
        event.preventDefault();

        if (formLiveStatus) {
          formLiveStatus.textContent =
            'There are errors in the form. Please review the highlighted fields.';
        }

        if (firstInvalid) {
          firstInvalid.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          firstInvalid.focus();
        }

        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.textContent = 'Sending...';
      }

      if (formLiveStatus) {
        formLiveStatus.textContent =
          'Your conversation request is being sent.';
      }

      /*
       * Do not call preventDefault here.
       * A valid form must submit normally to Shopify.
       * Shopify reloads the page and form.posted_successfully?
       * controls the genuine success message.
       */
    });

    var params = new URLSearchParams(window.location.search);
    var initialRoute = params.get('route');
    var initialProgramme = params.get('programme');

    if (initialRoute && findRouteRadio(initialRoute)) {
      selectRoute(initialRoute, initialProgramme, false);
    }
  }

  function initialiseForms(scope) {
    var root = scope || document;

    root
      .querySelectorAll('form[id^="route-form-"]')
      .forEach(initStartForm);
  }

  initialiseForms(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialiseForms(event.target);
  });
})();